"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const characteristics_1 = require("../@types/characteristics");
const characteristics = {
    [characteristics_1.AlignType.STANDARD]: {
        all: {
            split: /\s+/,
            columnCount: [6, 7],
            columns: [
                'ctg1',
                'start1',
                'end1',
                'ctg2',
                'start2',
                'end2',
                'color:opacity',
            ],
        },
    },
    [characteristics_1.AlignType.BLAST]: {
        all: {
            split: '\t',
            columnCount: 12,
            columns: [
                'ctg1',
                'ctg2',
                'identity',
                'alignLen',
                'otherNumber',
                'otherNumber',
                'start1',
                'end1',
                'start2',
                'end2',
                'evalue',
                'bitScore',
            ],
        },
    },
    [characteristics_1.AlignType.MINIMAP]: {
        all: {
            split: '\t',
            columns: [
                'ctg1',
                'len1',
                'start1',
                'end1',
                'minimapStrand',
                'ctg2',
                'len2',
                'start2',
                'end2',
                'alignLen',
            ],
        },
    },
    [characteristics_1.AlignType.NUCMER]: {
        include: [
            {
                startsWith: 'NUCMER',
            },
            {
                content: ['[S1]', '[TAGS]', '|'],
            },
        ],
    },
    [characteristics_1.AlignType.NUCMER_T]: {
        include: [
            {
                startsWith: 'NUCMER',
            },
            {
                content: ['[S1]', '[TAGS]'],
                exclude: {
                    content: '|',
                },
            },
        ],
    },
    [characteristics_1.AlignType.NUCMER_B]: {
        all: {
            split: '\t',
            columnCount: 21,
            columns: {
                [0]: 'ctg2',
                [2]: 'len2',
                [3]: 'NUCMER',
                [5]: 'ctg1',
                [6]: 'start2',
                [7]: 'end2',
                [8]: 'start1',
                [9]: 'end1',
                [10]: 'identity',
                [11]: 'identity',
                [12]: 'alignLen',
                [17]: 'nucmerStrand',
                [18]: 'len1',
            },
        },
    },
    [characteristics_1.AlignType.UNKNOWN]: {}
};
exports.default = characteristics;
